import Form from "react-bootstrap/Form";
import useFilter from "customHooks/useFilter";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import { useState } from "react";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";

function PolesReportFilter() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();

  const { polesDomains, polesFields, polesLayer, govsList, munsLayer } = map;

  const [munsList, setMunsList] = useState([]);

  const processData = (res) =>
    res.map((item) => ({
      ...item,
      StatusName: item.StatusName ? item.StatusName : "بانتظار التركيب",
    }));
  const { methods, handleResetFilter, onSubmitOfEsri } = useFilter({
    domains: polesDomains,
    fields: polesFields,
    featureLayer: polesLayer,
    objName: "polesReportList",
    reducerOrState: "reducer",
    queryFeaturesOptions: { orderByFields: ["Installation_Date DESC"] },
    dispatch: dispatchMap,
    processData,
  });
  const { register, handleSubmit } = methods;

  const onSubmit = (data) => {
    const tempData = { ...data };
    let injectedQuery = "";
    if (tempData.Status === "null") injectedQuery = "Status IS NULL";
    onSubmitOfEsri(tempData, injectedQuery);
  };

  const handleChangeGov = async (e) => {
    handleLoading(dispatchLoading, true);
    try {
      const govName = e.target.value;
      const { res: munsRes } = await getEsriDataFromLayer({
        featureLayer: munsLayer,
        query: `Governorate_English_Name  LIKE '%${govName}%'`,
      });

      setMunsList(munsRes);
    } catch (error) {
      console.log(error);
    }
    handleLoading(dispatchLoading, false);
  };

  return (
    <form id="search" onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="input input-md" controlId="formBasicEmail">
        <Form.Label>Pole ID</Form.Label>
        <Form.Control
          {...register("Point_ID")}
          autoComplete="false"
          type="text"
          placeholder="Search by Pole ID"
        />
      </Form.Group>
      <div className="select">
        <Form.Label>Category</Form.Label>
        <Form.Select defaultValue="" {...register("Category")}>
          <option value="">All</option>
          {polesDomains &&
            polesDomains?.Category?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Governorate</Form.Label>
        <Form.Select
          defaultValue=""
          {...register("Governorate", {
            onChange: (e) => handleChangeGov(e),
          })}
        >
          <option value="">All</option>
          {govsList &&
            govsList.map((item) => (
              <option
                key={item.Governorate_English_Name}
                value={item.Governorate_English_Name}
              >
                {item.Governorate_Arabic_Name}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Municipality</Form.Label>
        <Form.Select
          defaultValue=""
          {...register("Municipality")}
          disabled={!munsList?.length}
        >
          <option value="">All</option>
          {munsList &&
            munsList.map((item) => (
              <option key={item.Municipality_E_1} value={item.Municipality_E_1}>
                {item.Municipality_A_1}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Status</Form.Label>
        <Form.Select defaultValue="" {...register("Status")}>
          <option value="">All</option>
          <option value="null" key="awaiting-installation">
            بانتظار التركيب
          </option>
          {polesDomains?.Status &&
            polesDomains?.Status?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      <Form.Group className="input input-md" controlId="Installation_Date_from">
        <Form.Label>Installation Date (From)</Form.Label>
        <Form.Control type="date" {...register("Installation_Date_from")} />
      </Form.Group>
      <Form.Group className="input input-md" controlId="Installation_Date_to">
        <Form.Label>Installation Date (To)</Form.Label>
        <Form.Control type="date" {...register("Installation_Date_to")} />
      </Form.Group>
      <div className="button-group">
        <button type="submit" form="search" className="btn btn--primary">
          Filter
        </button>
        <button
          onClick={() => {
            handleResetFilter();
          }}
          type="button"
          className="btn btn--primary"
        >
          Clear
        </button>
      </div>
    </form>
  );
}

export default PolesReportFilter;
